import React from "react";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { getSpacingClasses } from "../blocks/spacing";
import { IValuePropBarBlock } from "../models/value-props";
import { ValuePropsBar } from "./ValuePropsBar";

export const ValuePropsBarBlock = (props: {
    valuePropsData: IValuePropBarBlock;
}): React.ReactNode => {
    return (
        <div
            className={concatClassNames([
                "value-props-bar-block",
                props.valuePropsData.background_style?.style ?? "",
                props.valuePropsData.responsive_visibility?.visibility ?? "",
                props.valuePropsData.spacing
                    ? getSpacingClasses(props.valuePropsData.spacing)
                    : "",
            ])}
        >
            <ValuePropsBar valueProps={props.valuePropsData.value_props} />
        </div>
    );
};
